import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FacilityProvider } from "@/context/FacilityContext";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import FarmMockups from "@/pages/FarmMockups";
import SchedulePrintPage from "@/pages/SchedulePrintPage";
import OfferResponsePage from "@/pages/OfferResponsePage";
import MeetingSignupPage from "@/pages/MeetingSignupPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <FacilityProvider>{children}</FacilityProvider>;
}

export default function App() {
  React.useEffect(() => {
    document.title = "Patient Access Scheduler";
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/mockups" element={<FarmMockups />} />
            <Route path="/print/schedule" element={<Protected><SchedulePrintPage /></Protected>} />
            <Route path="/offer/:token" element={<OfferResponsePage />} />
            <Route path="/offer/:token/:action" element={<OfferResponsePage />} />
            <Route path="/meeting-signup/:token" element={<MeetingSignupPage />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
